import { IoMdClose } from 'react-icons/io';
import { FiCheckCircle, FiAlertCircle, FiInfo } from 'react-icons/fi';
import './Banner.css';

const ICONS = {
  success: FiCheckCircle,
  error: FiAlertCircle,
  info: FiInfo,
};

const Banner = ({ type = 'info', message, onDismiss }) => {
  const Icon = ICONS[type] || FiInfo;
  return (
    <div className={`banner banner-${type}`}>
      <Icon className="banner-icon" />
      <div className="banner-message">{message}</div>
      {onDismiss && (
        <button className="banner-close" onClick={onDismiss} aria-label="Dismiss">
          <IoMdClose />
        </button>
      )}
    </div>
  );
};

export default Banner;
